import React, { useContext, useEffect, useState } from "react";
import "./panvel.css";
import { useLayerFunc } from "../Main/layerFunc";
import { GlobalContext } from "../../App";

function KamotheWardProj() {
  const { LayerChange, TileLayerChange, handleOpen } = useLayerFunc();
  const { SetLogout } = useContext(GlobalContext);

  useEffect(() => {
    SetLogout(true);
  }, []);

  return (
    <>
      <details
        className="baseline"
        onToggle={() => handleOpen("Kamothe_ward_Kamothe_Boundary")}
      >
        <summary>Kamothe-Ward</summary>
        <div className="baseline-cont">
          <div className="opt-div">
            <input
                  value="Kamothe_ward_Kamothe_Boundary"
                  id="Kamothe_ward_Kamothe_Boundary"
                  className="form-check-input check-map"
                  type="checkbox"
                  onChange={(e) =>
                    LayerChange(e.target.value, e.target.id, e.target.checked)
                  }
                  
                />
            <label>Boundary</label>
          </div>
          <details id="townD">
            <summary className="townS">Baseline</summary>
            <div className="town-cont">
              <div className="opt-div">
                <input
                  value="Kamothe_Road_Network"
                  id="Kamothe_Road_Network"
                  className="form-check-input check-map"
                  type="checkbox"
                  onChange={(e) =>
                    LayerChange(e.target.value, e.target.id, e.target.checked)
                  }
                />
                <label>Road</label>
              </div>
             
              <div className="opt-div">
                <input
                  value="Kamothe_Railway_Network"
                  id="Kamothe_Railway_Network"
                  className="form-check-input check-map"
                  type="checkbox"
                  onChange={(e) =>
                    LayerChange(e.target.value, e.target.id, e.target.checked)
                  }
                />
                <label>Railways</label>
              </div>
                <div className="opt-div">
                  <input
                    value="Kamothe_Tree"
                    id="Kamothe_Tree"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Tree</label>
                </div>

                <div className="opt-div">
                  <input
                    value="Kamothe_Water"
                    id="Kamothe_Water"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(
                        e.target.value,
                        e.target.id,
                        e.target.checked,
                        false,
                        true
                      )
                    }
                  />
                  <label>Waterbody</label>
                </div>
             <div className="opt-div">
                <input
                  value="Kamothe_Mangrove_Swamps"
                  id="Kamothe_Mangrove_Swamps"
                  className="form-check-input check-map"
                  type="checkbox"
                  onChange={(e) =>
                    LayerChange(e.target.value, e.target.id, e.target.checked)
                  }
                />
                <label>Mangrove Swamps</label>
              </div>
              <div className="opt-div">
                <input
                  value="Kamothe_Total_Builtup"
                  id="Kamothe_Total_Builtup"
                  className="form-check-input check-map"
                  type="checkbox"
                  onChange={(e) =>
                    LayerChange(e.target.value, e.target.id, e.target.checked)
                  }
                />
                <label>Total Builtup</label>
              </div>
            </div>  
          </details>

            <details id="townD">
              <summary className="townS">Town Planning</summary>
              <div
                className="town-cont"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyItems: "right",
                }}
              >
                <div className="opt-div">
                  <input
                    value="Kamothe_Prabhag"
                    id="Kamothe_Prabhag"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Prabhag</label>
                </div>
                 <div className="opt-div">
                  <input
                    value="Kamothe_Panvel_Jurisdiction"
                    id="Kamothe_Panvel_Jurisdiction"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Jurisdiction</label>
                </div>
                <div className="opt-div">
                  <input
                    value="Kamothe_Nodal_Sector"
                    id="Kamothe_Nodal_Sector"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Sectors</label>
                </div>
                <div className="opt-div">
                  <input
                    value="Kamothe_Nodal_Plot"
                    id="Kamothe_Nodal_Plot"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Plots</label>
                </div>
                <div style={{ display: "none" }} className="opt-div">
                  <input
                    value="Kamothe_Village_Boundary"
                    id="Kamothe_Village_Boundary"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Village Boundary</label>
                </div>
                <div style={{ display: "none" }} className="opt-div">
                  <input
                    value="Kamothe_Village_Survey"
                    id="Kamothe_Village_Survey"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Village survey</label>
                </div>
              
              </div>
            </details>         

          <details id="townD">
              <summary className="townS">Builtup Change</summary>
              <div
                className="town-cont"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyItems: "right",
                }}
              >
                <div className="opt-div">
                  <input
                    value="Kamothe_authorised"
                    id="Kamothe_authorised"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Authorised</label>
                </div>
                <div className="opt-div">
                  <input
                    value="Kamothe_Unauthorised"
                    id="Kamothe_Unauthorised"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Unauthorised</label>
                </div>
                <div className="opt-div">
                  <input
                    value="Kamothe_Other_Authority"
                    id="Kamothe_Other_Authority"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Other Authority</label>
                </div>
                 <div className="opt-div">
                  <input
                    value="Kamothe_Pending"
                    id="Kamothe_Pending"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label> Pending </label>
                </div>
                <div className="opt-div">
                  <input
                    value="Kamothe_shed"
                    id="Kamothe_shed"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label> Shed </label>
                </div>
                <div className="opt-div">
                  <input
                    value="Kamothe_total_builtup_jan2023"
                    id="Kamothe_total_builtup_jan2023"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Total builtup jan2023</label>
                </div>
              </div>
            </details>

            <details id="townD">
            <summary className="townS">Images</summary>
            <div className="town-cont mb-3">
              <div className="opt-div">
                <input
                  value="Jan_2023"
                  id="Kamothe_ward_Kamothe_Boundary"
                  onChange={(e) =>
                    TileLayerChange(
                      e.target.value,
                      e.target.id,
                      "Jan 2023",
                      e.target.checked
                    )
                  }
                  className="form-check-input check-map"
                  type="checkbox"
                />
                <label>Jan 2023</label>
              </div>
              <div className="opt-div">
                <input
                  value="March_2025"
                  id="Kamothe_ward_Kamothe_Boundary"
                  onChange={(e) =>
                    TileLayerChange(
                      e.target.value,
                      e.target.id,
                      "March 2025",
                      e.target.checked
                    )
                  }
                  className="form-check-input check-map"
                  type="checkbox"
                />
                <label>March 2025</label>
              </div>
            </div>
          </details>
        </div>
      </details>
    </>
  );
}

export default KamotheWardProj;
